import Vue from 'vue'
import Vuex from 'vuex'

import global from './modules/global'
import pages from './modules/pages'
import articles from './modules/articles'
import loader from './modules/loader'

// Vuex
Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        global,
        pages,
        articles,
        loader,
    },
    strict: process.env.NODE_ENV !== 'production'
})

export default store
